/**
 * Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers";
import SelectGlobal from "../SelectGlobal";

/**
 *Styles
 */
import "./Birthday.scss";
import StepWrapper from "../StepWrapper";
import ButtonGlobal from "../ButtonGlobal";

const Birthday = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorBirthday, setErrorBirthday] = useState(null);

  const handlerSubmit = () => {
    const { status, error } = validateAge(data.month, data.day, data.year);
    if (!status) {
      setErrorBirthday(error);
      return;
    }

    setData({
      ...data,
      birthday: getBirthdayInFormat(data.year, data.month, data.day),
    });
    setStep(step + 1);
    simplyClick("cl_lnd_am31_date_birth_cont", {
      birthday: getBirthdayInFormat(data.year, data.month, data.day),
    });
  };
  const handlerStepBack = () => {
    setStep(step - 1);
    simplyClick("cl_lnd_am31_date_birth_back", null);
  };

  const handleAddMonth = (e) => {
    setErrorBirthday(null);
    setData({ ...data, month: e.target.value });
  };
  const handleAddDay = (e) => {
    setErrorBirthday(null);
    setData({ ...data, day: e.target.value });
  };

  const handleAddYear = (e) => {
    setErrorBirthday(null);
    setData({ ...data, year: e.target.value });
  };
  return (
    <StepWrapper
      className="birthday"
      step={step}
      stepLabel={"Please state your date of birth"}
    >
      <div className="date__wrapper">
        <SelectGlobal
          dateArray={getMonths()}
          data={data?.month}
          handleChange={handleAddMonth}
          label={"Month"}
          error={errorBirthday}
        />
        <SelectGlobal
          dateArray={getDate()}
          data={data?.day}
          handleChange={handleAddDay}
          label={"Day"}
          error={errorBirthday}
        />
        <SelectGlobal
          dateArray={getYears()}
          data={data?.year}
          handleChange={handleAddYear}
          label={"Year"}
          error={errorBirthday}
        />
      </div>
      {errorBirthday && <p className="error-text">{errorBirthday}</p>}
      <p className="birthday__text">
        By proceeding you confirm that you are fully legally capable to use
        website and major or at least 18 years old
      </p>
      <div className="button_wrap birthday">
        <ButtonGlobal text={"Continue"} cb={() => handlerSubmit()} />
        <ButtonGlobal
          text={"Back"}
          cb={handlerStepBack}
          back={true}
          iconLeft={true}
        />
      </div>
    </StepWrapper>
  );
};
export default Birthday;
